/**
 * Canonical Single Source of Truth for My Daily Direct (MDD) Support & Contact.
 *
 * Strict business rule: All support links, telephone dials, WhatsApp links,
 * and customer care references across ALL MDD applications must ONLY use
 * this single constant: 9180348180.
 */
export const MDD_SUPPORT_PHONE = "9180348180";
export const MDD_SUPPORT_PHONE_DISPLAY = "+91 9180348180";
export const MDD_SUPPORT_WHATSAPP_NUMBER = "919180348180";
export const MDD_SUPPORT_WHATSAPP_URL = "https://wa.me/919180348180";
export const MDD_SUPPORT_TEL_URL = "tel:+919180348180";
export const MDD_SUPPORT_EMAIL = "support@mydailydirect.in";

/**
 * Official Government of India GST Registration Details (Form GST REG-06).
 * Registration Certificate Date: 21/10/2026
 * Trade Name: My Daily Direct
 * Registration Number (GSTIN): 29AKVPN0842L1ZF
 * PAN: AKVPN0842L
 * Constitution of Business: Proprietorship
 */
export const MDD_GSTIN = "29AKVPN0842L1ZF";
export const MDD_PAN = "AKVPN0842L";
export const MDD_TRADE_NAME = "My Daily Direct";
export const MDD_CONSTITUTION = "Proprietorship";
export const MDD_GST_STATE = "Karnataka";
export const MDD_GST_STATE_CODE = "29";
export const MDD_GST_REGISTRATION_DATE = "21/10/2026";
export const MDD_GST_REGISTRATION_TYPE = "Regular";

export const MDD_REGISTERED_ADDRESS = {
  floorNo: "1st Floor",
  buildingNo: "No.4, Kno.90/3",
  premisesName: "AMP Appartment",
  roadStreet: "Opp. Bata Shop Road",
  landmark: "Near apr function hall",
  locality: "Hongasandra",
  city: "Bengaluru",
  district: "Bengaluru Urban",
  state: "Karnataka",
  pinCode: "560068",
  stateCode: "29",
  lines: [
    "No.4, Kno.90/3, 1st Floor, AMP Appartment",
    "Opp. Bata Shop Road, Near apr function hall, Hongasandra",
    "Bengaluru, Bengaluru Urban, Karnataka - 560068",
  ],
  singleLine:
    "No.4, Kno.90/3, 1st Floor, AMP Appartment, Opp. Bata Shop Road, Near apr function hall, Hongasandra, Bengaluru, Karnataka - 560068",
};
